export default class ContactInfo {
  constructor() {
    this.init();
  }

  init() {
    this.fullName = null;
    this.email = null;
    this.category = null;
    this.message = null;
    this.token = null;
  }

  get payload() {
    return {
      name: this.fullName,
      email: this.email,
      subject: this.category,
      message: this.message,
      token: this.token,
    };
  }
};